<template>
    <div class="cents">
        <van-nav-bar
            :title="$t('ewmkm')"
            left-arrow
            safe-area-inset-top
            style="background-color: #1ABC9C;"
            @click-left="goto"
        />
        <div class="ewmcode">
            <vue-qr :size="210" :margin="10" :auto-color="true" :dot-scale="1" :text="appSrc" />
            <p>
                {{$t('qjzewmdzjt')}}
            </p>
        </div>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
import {buildUserQRcode} from '@/utils/index'
export default {
    components:{
        VueQr
    },
    data(){
        return{
            appSrc:'',
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
        }
    },
    mounted(){
        this.ppp()
        this.handeldow()
    },
    methods:{
        // 返回
        goto(){
            this.$router.go(-1)
        },
        handeldow(){
            this.clearTimeSet=setInterval( () =>{
                this.ppp()
            }, 2000);
        },
        ppp(){
            let timestamp = Math.round(new Date().getTime()/1000);
           let aa=  buildUserQRcode(this.Userof.user_id,timestamp,timestamp)
           this.appSrc= aa
           console.log(aa)
        }
    },
    beforeDestroy() {    //页面关闭时清除定时器  
        clearInterval(this.clearTimeSet);
    },
}
</script>
<style scoped>
.ewmcode{
    margin-top: 60px;
}


.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
</style>